import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Why_india extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Why Engage With India
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>About Us</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Why Engage With India</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section
                    className="about-section section-padding fix bg-cover"
                    style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                >
                    <div className="container">
                        <div className="about-wrapper style-2">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="about-image-items">
                                        <div className="circle-shape">
                                            <img src="assets/img/about/circle.png" alt="shape-img" />
                                        </div>
                                        <div
                                            className="about-image-1 bg-cover wow fadeInLeft"
                                            data-wow-delay=".3s"
                                            style={{ backgroundImage: 'url("assets/img/IndustryInfo_11.jpg")' }}
                                        >
                                            <div className="about-image-2 wow fadeInUp" data-wow-delay=".5s">
                                                <img src="assets/img/about/invest_india.jpg" style={{border:'2px solid black'}} alt="about-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 mt-4 mt-lg-0">
                                    <div className="about-content">
                                        <div className="section-title mb-3 mxw-650">
                                            <div className="subtitle">
                                                {" "}
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span>Why Engage With India</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title">Building India's Future</h2>
                                        </div>
                                        <div className="why_india_css">
                                            <ul>
                                                <li>
                                                    4th Largest Economy with GDP Growth: 8.4% (FY24) &amp;
                                                    Forecasted Growth: 7% (FY25)
                                                </li>
                                                <li>
                                                    Vision to be self-reliant (Atmanirbhar) by 2047 – the Amrit
                                                    kaal
                                                </li>
                                                <li>
                                                    India is establishing itself as the next Manufacturing hub for
                                                    technology and engineering products
                                                </li>
                                                <li>
                                                    India has huge resources and an abundant raw material supply.
                                                </li>
                                                <li>
                                                    India has a very large domestic market and has the
                                                    second-largest working population. There is high disposable
                                                    income accounting for per capita income of ~$2,350 in FY 24.
                                                </li>
                                                <li>
                                                    India has a rich textile culture and heritage. It is one of
                                                    the top five producers attributing a 4% share in the global
                                                    trade in textiles and apparel, 23% in world cotton, and 95% in
                                                    handwoven fabric.
                                                </li>
                                                <li>Multi-skilled people with comparatively low labour cost</li>
                                                <li>
                                                    The young population, with a median age of 28 years is highly
                                                    energetic and shows eagerness for technology adoption.
                                                </li>
                                                <li>Global Exposure</li>
                                                <li>
                                                    Focus approach through supportive Government policies like
                                                    product link schemes, FDI, and infrastructure development.
                                                </li>
                                            </ul>
                                        </div>
                                        {/* <div class="about-author">
                          <div class="about-button wow fadeInUp" data-wow-delay=".5s">
                              <a href="about.html" class="theme-btn">
                                  Explore More
                                  <i class="fa-solid fa-arrow-right-long"></i>
                              </a>
                          </div>
                      </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>




                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Why_india));